class SpeechDictation {
    constructor() {
        if (window.SpeechRecognition || window.webkitSpeechRecognition) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            this.recognition = new SpeechRecognition();
            this.recognition.lang = 'es-ES';
            this.recognition.continuous = true;
        } else {
            alert('Tu navegador no soporta la API de Web Speech');
            this.recognition = null;
        }
    }

    startDictation(updateCallback, initialText = '') {
        if (!this.recognition) return;
    
        this.transcript = initialText;
    
        this.recognition.onresult = (event) => {
            let interimTranscript = '';
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                if (event.results[i].isFinal) {
                    this.transcript += event.results[i][0].transcript;
                } else {
                    interimTranscript += event.results[i][0].transcript;
                }
            }

            const finalTranscript = this.transcript + interimTranscript;
            if (typeof updateCallback === 'function') {
                updateCallback(finalTranscript);
            }
        };

        this.recognition.onerror = (event) => {
            console.error('Error en la grabación: ', event.error);
        };

        this.recognition.start();
    }

    stopDictation() {
        if (this.recognition) {
            this.recognition.stop();
        }
    }
}

export default SpeechDictation;